import { useState } from 'react';
import { Container, Row, Col, Card, Button } from 'reactstrap';
import { resetState } from 'Features/Learning/PopupNotification/addPopupNotificationSlice';
import { useSelector, useDispatch } from 'react-redux';
import PopupNotificationBox from './PopupNotificationBox';
import PopupNotificationFilter from './PopupNotificationFilter';

const PopupNotificationContain = () => {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const cards = useSelector(state => state.PopupNotification.data.data)

  const toggle = () => setModal(prev => !prev);

  const handleAdd = (e) => {
    dispatch(resetState());
  };

  return (
    <Container fluid={true}>
      <Col md="12" className="project-list">
        {cards && (
          <Card>
            <Row>
              <Col>
                <Button color="primary" onClick={e => {
                  e.preventDefault();
                  handleAdd(e);
                  toggle();
                }}>
                  <i className="fa fa-plus-circle fa-lg"></i> Tambah Popup Notification Baru
                </Button>
              </Col>
            </Row>
          </Card>
        )}
      </Col>
      <Row className='learning-block'>
        <Col xl="9" className='xl-80'>
          <Row>
            <PopupNotificationBox modal={modal} toggle={toggle} />
          </Row>
        </Col>
        {cards && (
          <PopupNotificationFilter />
        )}
      </Row>
    </Container>
  );
};

export default PopupNotificationContain;